import React from "react";

const Agric = () => {
  return (
    <div>
      <section
        id="page-title"
        className="page-title page-title-layout10 bg-overlay bg-parallax text-center"
      >
        <div className="bg-img">
          <img src="../assets/images/page-titles/13.jpg" alt="background" />
        </div>
        <div className="container">
          <div className="row">
            <div className="col-sm-12 col-md-12 col-lg-12">
              <h1 className="pagetitle__heading">Agric Solution</h1>
              <nav aria-label="breadcrumb">
                <ol className="breadcrumb justify-content-center">
                  <li className="breadcrumb-item">
                    <a href="/">Home</a>
                  </li>
                  <li className="breadcrumb-item">
                    <a href="/products">Products</a>
                  </li>
                  <li className="breadcrumb-item active" aria-current="page">
                    Agric Solution
                  </li>
                </ol>
              </nav>
            </div>
            {/* /.col-lg-12 */}
          </div>
          {/* /.row */}
        </div>
        {/* /.container */}
      </section>
      {/* /.page-title */}
      {/* ======================
        Text Content Section
      ========================= */}
      <section id="textContentSection" className="text-content-section">
        <div className="container">
          <div className="row">
            <div className="col-sm-12 col-md-12 col-lg-2" />
            <div className="col-sm-12 col-md-12 col-lg-8">
              <div className="text__block">
                <h5 className="text__block-title">Agric Solution</h5>
                <div>
                  <p>
                    <img
                      alt="ra im"
                      height={336}
                      src="assets/images/products/ag1.png"
                      width={623}
                    />
                  </p>
                  <p>Irrigation</p>
                  <p>
                    The company relies on French Technology, with products and
                    solutions designed specifically for developing market
                    economies. Mahindra provides complete solutions for
                    agriculture with a focus on Micro-Irrigation, Pumps &amp;
                    inter-related requirements of fertigation and agronomic
                    support.
                  </p>
                  <p>
                    <img
                      alt="A person spraying a field with a helicopterDescription automatically generated with low confidence"
                      height={269}
                      src="assets/images/products/ag2.png"
                      width={474}
                    />
                  </p>
                  <p>
                    The company manufactures Online &amp; Integrated Driplines
                    (Flat &amp; Round Inline), Overhead Sprinkler Systems,
                    Mini-Impact Sprinklers, Piping for lift irrigation schemes
                    in an ultra-modern extrusion and injection molding plant.
                    They also produce and supply PE pipes ranging from 3 to 315
                    mm in size with complete fittings and installation tools,
                    and have a wide range of products including Screen, Disc,
                    Sand, Hydro cyclone filters, Fertilizer Tanks, Venturis,
                    etc. to meet the requirement of farmers.
                  </p>
                  <p>
                  </p>
                  <p>
                  </p>
                  <p>Greenhouse</p>
                  <p>
                    Green House farming in Nigeria is planting and growing crops
                    in an enclosed environment, Greenhouse Farming is the
                    process of cultivating crops and vegetable in a greenhouse
                    ecosystems environment. Cultivation in greenhouses is a
                    practice that has allowed farmers to increase their
                    performance, while improving the quality of products,
                    isolating them in micro-ecosystems that have the ideal
                    conditions for plants to grow healthy, strong and beautiful.
                  </p>
                  <p>
                    <img
                      alt="containing greenhouse, building, grass, plantDescription automatically generated"
                      height={269}
                      src="assets/images/products/ag3.png"
                      width={474}
                    />
                  </p>
                  <p>Tractors</p>
                  <p>
                    Responding to the need for quality products and services to
                    the farming sector, our Agric focuses on promoting the use
                    of modern agricultural technology to farmers and improving
                    productivity at the grassroots level.
                  </p>
                  <p>
                    Our Agric is a prominent player in the sales and service of
                    tractors and implements, spare parts, tools, and equipment.
                    Our diverse range of products includes rotary tillers,
                    tipping trailers, disc harrows, disc riders, Tyne riders,
                    land levers, post hole diggers and rotary slashers etc.
                  </p>
                  <p>
                    <img
                      alt=" grass, outdoor, agricultural machinery, plantDescription automatically generated"
                      height={232}
                      src="assets/images/products/ag4.png"
                      width={347}
                    />
                    <img
                      alt="A red tractor with large wheelsDescription automatically generated with medium confidence"
                      height={228}
                      src="assets/images/products/ag5.png"
                      width={266}
                    />
                  </p>
                  <p>
                    <img
                      alt=" drink, soft drink, juice, cocktailDescription automatically generated"
                      height={270}
                      src="assets/images/products/ag6.png"
                      width={358}
                    />
                  </p>
                  <p>Palm oil</p>
                  <p>
                    The production of palm oil in Nigeria reached 1.4 million
                    metric tons. Between 2009 and 2022, the production quantity
                    generally increased, registering the highest growth in 2010,
                    when it grew by roughly 14 percent. From 2014 onwards, the
                    output from palm oil production followed a rising trend.
                  </p>
                  <p>
                    <img
                      alt="A bowl of sesame seedsDescription automatically generated"
                      height={251}
                      src="assets/images/products/ag7.png"
                      width={377}
                    />
                  </p>
                  <p>Sesame Seeds</p>
                  <p>
                    The seed has numerous uses, one of which is it’s being a
                    very good source of vegetable oil that contains no
                    cholesterol, making it the most demanded vegetable oil in
                    the world. Nigeria has been one of the highest sesame seed
                    producing countries over the years, making the seed a very
                    important component of the country’s agricultural export.
                  </p>
                  <p>
                    <br />
                  </p>
                  <p>
                    Tropical areas are where the seeds are mainly cultivated.
                    Due to the drought-resistant nature of the sesame plant, it
                    thrives excellently in the Northern part of the country and
                    averagely in some parts of Southwest.
                  </p>
                  <p>
                    <br />
                  </p>
                  <p>
                    <img
                      alt="A pile of cashew nutsDescription automatically generated"
                      height={208}
                      src="assets/images/products/ag8.png"
                      width={358}
                    />
                  </p>
                  <p>Cashew Seed</p>
                  <p>
                    The cashew seed is often considered a nut in the culinary
                    sense; this cashew nut is eaten on its own, used in recipes,
                    or processed into cashew cheese or cashew butter. Like the
                    tree, the nut is often simply called cashew. Culinary uses
                    for cashew seeds in snacking and cooking are similar to
                    those for all tree seeds called nuts.
                  </p>
                  <p>
                    <img
                      alt=" nuts & seeds, plantDescription automatically generated"
                      height={374}
                      src="assets/images/products/ag9.png"
                      width={390}
                    />
                    <br />
                    <b>Cocoa Beans</b>
                    <br />
                    Cocoa beans are the seeds of cacao plants that are extracted
                    from its fruit called “pods”. When the seeds are removed
                    from pods, they are very moist. So, they need to be roasted
                    to make them dry for making cocoa powder. There are many
                    products that are made from cocoa beans and many of them
                    have various health benefits.
                  </p>
                  <p>
                    <br />
                  </p>
                  <p>
                    <img
                      alt=" honeycomb, beehive, yellow, foodDescription automatically generated"
                      height={267}
                      src="assets/images/products/ag10.png"
                      width={401}
                    />
                    <br />
                    <br />
                    Natural Honey
                  </p>
                  <p>
                    Honey is a sweet, golden liquid made by honeybees. Honeybees
                    store their honey in small, hexagonal cups called a
                    honeycomb. Natural honey comes straight from the honeycomb.
                    &nbsp;Natural honey is a sweet, flavorful liquid food of
                    high nutritional value. It’s very high in beneficial plant
                    compounds and offers several health benefits. Honey is
                    particularly healthy when used instead of refined sugar,
                    which is 100% empty calories.
                  </p>
                  <p>Ginger Powder</p>
                  <p>
                    Ginger is a tropical flowering plant that originally grew in
                    Southeast Asia but is now widely available from growers
                    around the world. The leafy plant grows to about three feet
                    tall and produces clusters of greenish-purple flowers. It’s
                    harvested by pulling the entire plant out of the soil,
                    removing the leaves and cleaning the root.
                  </p>
                  <p>
                    <br />
                  </p>
                  <p>
                    Ginger can be eaten fresh, dried, and stored as a spice, or
                    made into tablets, capsules, and liquid extracts. The demand
                    for ginger in the international market has grown remarkably
                    because the root is now being used as a raw material in the
                    manufacturing process and in the cosmetic industry as a
                    fragrance in soaps and beauty products.
                  </p>
                  <p>
                    Types of Ginger: Sun-Dried Split Ginger, Fresh Ginger,
                    Ginger Powder
                  </p>
                  <p>
                    <img
                      alt=" food, snack, spiceDescription automatically generated"
                      src="assets/images/products/soy.png"
                    />
                    <br />
                    <br />
                    Soybeans
                  </p>
                  <p>
                    Soybeans, (Glycine max), also called soja bean, is an annual
                    legume of the pea family and its edible seed. The soybean is
                    economically the most important bean in the world, providing
                    vegetable protein for millions of people and ingredients for
                    hundreds of chemical products. As soybeans mature in the
                    pot, they ripen into hard, dry beans. Although most soybeans
                    are yellow, there are also rare varieties that are black,
                    brown, or green colored. Soybeans are healthful and rich in
                    protein, giving them numerous nutritional uses. It can be
                    consumed in milk alternatives and taken in the form of
                    supplements.
                  </p>
                  <p>
                    <br />
                  </p>
                  <p>
                    Soybeans are healthful and rich in protein, giving them
                    numerous nutritional uses. It can be consumed in milk
                    alternatives and taken in the form of supplements.
                  </p>
                  <p>
                    <img
                      alt="A group of garlics and clovesDescription automatically generated with medium confidence"
                      height={307}
                      src="assets/images/products/ag12.png"
                      width={379}
                    />
                  </p>
                  <p>Garlic</p>
                  <p>
                    Garlic is a plant in the Allium (onion) family. It is
                    closely related to onions, shallots, and leeks. Each segment
                    of a garlic bulb is called a clove. There are about 10–20
                    cloves in a single bulb. Garlic grows in many parts of the
                    world and is a popular ingredient in cooking due to its
                    strong smell and delicious taste. However, throughout
                    ancient history, the main use of garlic was for its health
                    and medicinal properties.
                  </p>
                  <p>
                    <img
                      alt="A cotton plant on a white surfaceDescription automatically generated with low confidence"
                      height={273}
                      src="assets/images/products/ag13.png"
                      width={376}
                    />
                  </p>
                  <b>Cotton Lint</b>
                  <p>
                    Cotton is a soft, fluffy staple fiber that grows in a ball
                    around the seeds of cotton plants. &nbsp;It belongs to the
                    mallow family of plants. There are three primary products
                    derived from cotton production: cotton lint, linters, and
                    cottonseed. Cotton lint is used in making towels, clothing,
                    and shoestrings. The commercial varieties have been
                    developed over a long period, by selection and crossbreeding
                    of four distinct botanical species.
                  </p>
                  <p>
                    <img
                      alt=" food, dried fruitDescription automatically generated"
                      height={299}
                      src="assets/images/products/ag14.png"
                      width={348}
                    />
                  </p>
                  <p>
                    <b>Gum Arabic</b>
                    <br />
                    <br />
                    Gum Arabic is a soluble fiber obtained from Acacia Senegal
                    and Acacia Seyal trees grown in sub-Saharan Africa,
                    particularly Sudan. It is one of the most important
                    medicinal plants used in traditional, or alternative,
                    medicine.
                  </p>
                  <p>
                    Gum Arabic structure allows it to dissolve in cold or warm
                    water (meaning it’s water-soluble), making it easy to use in
                    a variety of ways. Because it is a natural, plant-derived
                    product, it’s suitable for vegans/vegetarians. It is also
                    naturally gluten-free, and well tolerated by most people
                    when used inappropriate/small amounts. It is used in the
                    food industry as a stabilizer, emulsifier, and thickening
                    agent.
                  </p>
                  <p>
                    <br />
                  </p>
                </div>
              </div>
              {/* /.text-block */}
            </div>
            {/* /.col-lg-8 */}
            <div className="col-sm-12 col-md-12 col-lg-2" />
          </div>
          {/* /.row */}
        </div>
        {/* /.container */}
      </section>
    </div>
  );
};

export default Agric;
